import React from 'react'
import { signedPercent, deltaClass } from '../lib/format'

// Week selector. The whole evaluation ships in one payload, so moving the
// scrubber is pure client state — no refetch, no spinner.
export default function WeekScrubber({ weeks, selected, onSelect, deltasByWeek }) {
  if (!weeks.length) return null

  return (
    <div>
      {/* The buttons grow to fill the row rather than hugging the left edge;
          min-width keeps them tappable, so they wrap on a narrow screen. */}
      <div className="flex flex-wrap gap-1 sm:gap-1.5">
        {weeks.map((week) => {
          const delta = deltasByWeek?.[week]
          const active = week === selected

          return (
            <button
              key={week}
              type="button"
              onClick={() => onSelect(week)}
              aria-pressed={active}
              className={`min-w-12 flex-1 rounded-md border px-1.5 py-1.5 text-center transition sm:min-w-14 sm:px-2.5 ${
                active
                  ? 'border-slate-100 bg-slate-100 text-slate-900'
                  : 'border-slate-700 bg-slate-900 hover:border-slate-500'
              }`}
            >
              <span className="block text-xs font-medium opacity-70">Wk {week}</span>
              <span
                className={`block text-xs font-semibold tabular-nums ${
                  active ? '' : deltaClass(delta)
                }`}
              >
                {signedPercent(delta)}
              </span>
            </button>
          )
        })}
      </div>

      <label className="mt-3 block">
        <span className="sr-only">Week</span>
        <input
          type="range"
          min={weeks[0]}
          max={weeks[weeks.length - 1]}
          value={selected}
          onChange={(event) => onSelect(Number(event.target.value))}
          className="w-full accent-slate-100"
        />
      </label>
    </div>
  )
}
